var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn-zzim-template',{attrs:{"title":_vm.titleStr,"wrapper-class":'check-like ' + _vm.getIconStyle,"check-state":_vm.value,"toggle-fn":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }